import React, { useCallback, useEffect, useState } from 'react'
import { Box, TextField } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import LoadingModal from 'src/components/common/LoadingModal'
import { AutoCompleteInput } from 'src/components/BuyPolicy/common/AutoCompleteInput'
import VehicleDetailsCard from 'src/components/BuyPolicy/common/VehicleDetailsCard'
import { useDispatch } from 'react-redux'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import { FILL_VEHICLE_DETAILS, VEHICLE_DETAILS } from 'src/utils/constants/Bike'

const BikeInfo = (props) => {
  const dispatch = useDispatch()
  const { logo, setIsActiveSection } = props
  const classes = useStyles()
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [brandList] = useState([])
  const [fuelTypeList] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [loading] = useState(false)
  const [modelList, setModelList] = useState([])
  const [variantList, setVariantList] = useState([])
  const [registerVehicleDetails, setRegisterVehicleDetails] = useState({
    brand: '',
    model: '',
    variant: '',
    fuelType: '',
    regDate: '',
  })

  const handleNext = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % 5)
  }

  const handlePrevious = () => {
    setSelectedIndex((prevIndex) => (prevIndex === 0 ? 5 - 1 : prevIndex - 1))
  }

  const handleSubmit = () => {
    if (
      !registerVehicleDetails?.brand ||
      !registerVehicleDetails?.model ||
      !registerVehicleDetails?.variant ||
      !registerVehicleDetails?.regDate ||
      !registerVehicleDetails?.fuelType
    ) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: FILL_VEHICLE_DETAILS,
        })
      )
    } else {
      setIsSubmitted(true)
      setIsActiveSection(false)
    }
  }

  const handlePrefillData = useCallback(() => {
    setModelList({})
    setVariantList({})
    setRegisterVehicleDetails({})
    setIsSubmitted(false)
    setIsActiveSection(false)
  }, [setIsActiveSection])

  const handleRegisterVehicleChange = (event, value, detailType) => {
    const updateVehicleDetails = { ...registerVehicleDetails }
    if (detailType) {
      switch (detailType) {
        case VEHICLE_DETAILS?.BRAND:
          updateVehicleDetails[detailType] = value
          break
        case VEHICLE_DETAILS?.MODEL:
          updateVehicleDetails[detailType] = value
          break
        case VEHICLE_DETAILS?.VARIANT:
          updateVehicleDetails[detailType] = value
          break
        case VEHICLE_DETAILS?.FUELTYPE:
          updateVehicleDetails[detailType] = value
          break
        default:
          break
      }
    }
    updateVehicleDetails[event?.target?.name] = event?.target?.value
    setRegisterVehicleDetails(updateVehicleDetails)
  }
  const handleBrandLabel = (option) => option?.genericName || ''
  const handleModelLabel = (option) => option?.modelGenericName || ''
  const handleVariantLabel = (option) => option?.genericVariantName || ''
  const handleFuelLabel = (option) => option?.genericName || ''

  const switchSelectComponent = () => {
    switch (selectedIndex) {
      case 0:
        return (
          <>
            <AutoCompleteInput
              optionList={brandList}
              handleChange={handleRegisterVehicleChange}
              value={registerVehicleDetails?.brand}
              handleOptionLabel={handleBrandLabel}
              label='Brand'
              nameLabel='brand'
            />
          </>
        )
      case 1:
        return (
          <>
            <AutoCompleteInput
              optionList={modelList}
              handleChange={handleRegisterVehicleChange}
              value={registerVehicleDetails?.model}
              handleOptionLabel={handleModelLabel}
              label='Model'
              nameLabel='model'
            />
          </>
        )
      case 2:
        return (
          <>
            <AutoCompleteInput
              optionList={variantList}
              handleChange={handleRegisterVehicleChange}
              handleOptionLabel={handleVariantLabel}
              value={registerVehicleDetails?.variant}
              label='Variant'
              nameLabel='variant'
            />
          </>
        )
      case 3:
        return (
          <>
            <AutoCompleteInput
              optionList={fuelTypeList}
              handleChange={handleRegisterVehicleChange}
              handleOptionLabel={handleFuelLabel}
              value={registerVehicleDetails?.fuelType}
              label='Fuel Type'
              nameLabel='fuelType'
            />
          </>
        )

      case 4:
        return (
          <>
            <TextField
              id='date'
              name='regDate'
              InputLabelProps={{
                shrink: true,
              }}
              type='text'
              placeholder='Registration Date'
              onFocus={(e) => {
                e.currentTarget.type = 'date'
              }}
              size='small'
              value={registerVehicleDetails?.regDate}
              onChange={(event) => handleRegisterVehicleChange(event)}
              InputProps={{
                className: classes.inputWidth,
              }}
            />
          </>
        )
      default:
        return null
    }
  }

  useEffect(() => {
    handlePrefillData()
  }, [handlePrefillData])

  return (
    <Box>
      <LoadingModal loading={loading} />
      <VehicleDetailsCard
        isSubmitted={isSubmitted}
        Logo={logo}
        registerVehicleDetails={registerVehicleDetails}
        switchSelectComponent={switchSelectComponent}
        handleSubmit={handleSubmit}
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        selectedIndex={selectedIndex}
        setIsSubmitted={setIsSubmitted}
        setIsActiveSection={setIsActiveSection}
        vehicleButtonName={'Bike'}
      />
    </Box>
  )
}

export default BikeInfo

const useStyles = makeStyles({
  inputWidth: {
    width: 140,
    fontSize: '12px !important',
  },
})
